import React, { lazy, memo } from 'react';
import { ShieldCheckIcon } from 'lucide-react';
// Update to use the direct Facebook Pixel tracking
// Memoize the component to prevent unnecessary re-renders
export const ProductOptions = memo(function ProductOptions() {
  // Function to handle redirection to checkout links
  const redirectToCheckout = (url, productName, price) => {
    try {
      // Track the checkout event with Facebook Pixel using the global function
      if (window.trackPurchaseClick && typeof window.trackPurchaseClick === 'function') {
        window.trackPurchaseClick(productName, price);
      } else if (window.fbq) {
        // Direct fallback if the global function isn't available
        window.fbq('track', 'InitiateCheckout', {
          content_name: productName,
          currency: 'USD',
          value: price
        });
      }
      // Redirect to checkout
      window.location.href = url;
    } catch (error) {
      console.error('Error tracking checkout:', error);
      // Still redirect even if tracking fails
      window.location.href = url;
    }
  };
  return <section id="product-options" className="w-full py-6 bg-white px-4" data-id="element-320">
      <div className="max-w-5xl mx-auto" data-id="element-321">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6" data-id="element-322">
          Choose Your Hair Revival Package
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-323">
          {/* Option 1 - 1 Month Supply */}
          <div className="border border-gray-200 rounded-lg overflow-hidden flex flex-col order-3 md:order-1" data-id="element-324">
            <div className="bg-blue-600 text-white text-center py-1.5 font-bold text-sm" data-id="element-325">
              STARTER SUPPLY
            </div>
            <div className="p-3 text-center flex-grow flex flex-col" data-id="element-326">
              <h3 className="text-lg font-bold mb-1 h-10 flex items-center justify-center" data-id="element-327">
                1-Month Supply
              </h3>
              <div className="h-48 w-full mx-auto mb-2 bg-white rounded-lg flex items-center justify-center" data-id="element-328">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4YgW3qS7gRyJPFUiZHqUwb/ChatGPT_Image_3_%CE%91%CF%85%CE%B3_2025__03_09_55_%CE%BC.%CE%BC.-removebg-preview.webp" alt="Hair Growth Oil 3.0 - 1 Month Supply" className="max-h-48 max-w-[85%] object-contain" style={{
                display: 'block',
                transformOrigin: 'center center',
                transform: 'scale(1)'
              }} width="176" height="176" data-id="element-329" />
              </div>
              <div className="mb-1 h-7 flex items-center justify-center" data-id="element-330">
                <span className="text-gray-500 line-through text-sm" data-id="element-331">
                  $100.00
                </span>
                <span className="text-red-600 font-bold text-lg ml-2" data-id="element-332">
                  $49.95
                </span>
              </div>
              <div className="bg-orange-500 text-white font-bold py-1 mb-3 text-sm" data-id="element-333">
                SAVE $50
              </div>
              <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full w-full mb-3 text-sm" onClick={() => redirectToCheckout('https://hair-haven.com/cart/58632120402269:1', 'Hair Growth Oil - 1 Month Supply', 49.95)} data-id="element-334">
                START MY HAIR REVIVAL
              </button>
              <div className="mt-auto" data-id="element-335">
                <div className="flex justify-center" data-id="element-336">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bY1QXvKGT817wbuoA99rqK/1723390134-PngItem_5294221_%281%29.webp" alt="100% Satisfaction Guaranteed" className="h-20 object-contain" loading="lazy" width="80" height="80" decoding="async" data-id="element-337" />
                </div>
                <p className="text-xs mt-1 text-center" data-id="element-338">
                  100% Satisfaction Guaranteed
                </p>
              </div>
            </div>
          </div>
          {/* Option 2 - 6 Month Complete Protocol */}
          <div className="border-2 border-green-500 rounded-lg overflow-hidden flex flex-col shadow-md order-1 md:order-2" data-id="element-339">
            <div className="bg-green-600 text-white text-center py-1.5 font-bold text-sm" data-id="element-340">
              LIMITED SPECIAL OFFER
            </div>
            <div className="p-3 text-center flex-grow flex flex-col" data-id="element-341">
              <h3 className="text-lg font-bold mb-1 h-10 flex items-center justify-center" data-id="element-342">
                6-Month Complete Protocol
              </h3>
              <div className="h-48 w-full mx-auto mb-2 bg-white rounded-lg flex items-center justify-center" data-id="element-343">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/kwBzoYbaQia2JM1h8bP2xk/ChatGPT_Image_22_%CE%A3%CE%B5%CF%80_2025__08_21_37_%CE%BC.%CE%BC.-removebg-preview.png" alt="Hair Growth Oil 3.0 - 6 Month Supply" className="max-h-48 max-w-[85%] object-contain" style={{
                display: 'block',
                transformOrigin: 'center center',
                transform: 'scale(1)'
              }} width="176" height="176" data-id="element-344" />
              </div>
              <div className="mb-1 h-7 flex items-center justify-center" data-id="element-345">
                <span className="text-gray-500 line-through text-sm" data-id="element-346">
                  $600.00
                </span>
                <span className="text-red-600 font-bold text-lg ml-2" data-id="element-347">
                  $29.95 each
                </span>
              </div>
              <div className="bg-orange-500 text-white font-bold py-1 mb-3 text-sm" data-id="element-348">
                SAVE $420 + FREE SHIPPING
              </div>
              <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-8 rounded-full w-full mb-3 text-sm" onClick={() => redirectToCheckout('https://hair-haven.com/cart/58632120402269:6', 'Hair Growth Oil - 6 Month Supply', 179.7)} data-id="element-349">
                GET BEST VALUE
              </button>
              <div className="mt-auto" data-id="element-350">
                <div className="flex justify-center" data-id="element-351">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bY1QXvKGT817wbuoA99rqK/1723390134-PngItem_5294221_%281%29.webp" alt="100% Satisfaction Guaranteed" className="h-20 object-contain" loading="lazy" width="80" height="80" decoding="async" data-id="element-352" />
                </div>
                <p className="text-xs mt-1 text-center" data-id="element-353">
                  100% Satisfaction Guaranteed
                </p>
              </div>
            </div>
          </div>
          {/* Option 3 - 3 Month Supply */}
          <div className="border border-gray-200 rounded-lg overflow-hidden flex flex-col order-2 md:order-3" data-id="element-354">
            <div className="bg-blue-600 text-white text-center py-1.5 font-bold text-sm" data-id="element-355">
              MOST POPULAR
            </div>
            <div className="p-3 text-center flex-grow flex flex-col" data-id="element-356">
              <h3 className="text-lg font-bold mb-1 h-10 flex items-center justify-center" data-id="element-357">
                3-Month Supply
              </h3>
              <div className="h-48 w-full mx-auto mb-2 bg-white rounded-lg flex items-center justify-center" data-id="element-358">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hmxDKLRvx21w7yDGyMxu1B/ChatGPT_Image_4_%CE%91%CF%85%CE%B3_2025__01_01_21_%CE%BC.%CE%BC.-removebg-preview.png" alt="Hair Growth Oil 3.0 - 3 Month Supply" className="max-h-48 max-w-[85%] object-contain" style={{
                display: 'block',
                transformOrigin: 'center center',
                transform: 'scale(1)'
              }} width="176" height="176" data-id="element-359" />
              </div>
              <div className="mb-1 h-7 flex items-center justify-center" data-id="element-360">
                <span className="text-gray-500 line-through text-sm" data-id="element-361">
                  $300.00
                </span>
                <span className="text-red-600 font-bold text-lg ml-2" data-id="element-362">
                  $39.95 each
                </span>
              </div>
              <div className="bg-orange-500 text-white font-bold py-1 mb-3 text-sm" data-id="element-363">
                SAVE $180 + FREE SHIPPING
              </div>
              <button className="bg-green-500 hover:bg-green-600 text-white font-bold py-2 px-4 rounded-full w-full mb-3 text-sm" onClick={() => redirectToCheckout('https://hair-haven.com/cart/58632120402269:3', 'Hair Growth Oil - 3 Month Supply', 119.85)} data-id="element-364">
                MAXIMIZE MY RESULTS
              </button>
              <div className="mt-auto" data-id="element-365">
                <div className="flex justify-center" data-id="element-366">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bY1QXvKGT817wbuoA99rqK/1723390134-PngItem_5294221_%281%29.webp" alt="100% Satisfaction Guaranteed" className="h-20 object-contain" loading="lazy" width="80" height="80" decoding="async" data-id="element-367" />
                </div>
                <p className="text-xs mt-1 text-center" data-id="element-368">
                  100% Satisfaction Guaranteed
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="text-center mt-6 text-sm text-gray-600 max-w-2xl mx-auto" data-id="element-369">
          <p className="mb-1" data-id="element-370">✓ Free shipping on all orders over $100</p>
          <p className="mb-1" data-id="element-371">✓ 90-day Follicular Revival Guarantee</p>
          <p data-id="element-372">✓ Made in FDA-registered, GMP-certified facilities</p>
        </div>
      </div>
    </section>;
});
export default {
  ProductOptions
};